import type { Condition, EffectWithImpact as Effect, IRule } from '@pepperhq/types-sdk';

export { Effect };

export type RuleResource = IRule<string>;

export interface Rule extends RuleResource {
    id: string;
}

export type AutomationConditionObject =
    | (string | { v: string; error?: string })
    | (string | { v: string; error?: string })[];

export type AutomationCondition = Condition & { object: AutomationConditionObject };

export interface AutomationRule extends Rule {
    conditions: AutomationCondition[];
}

export type CreateRuleResource = Omit<RuleResource, '_id' | 'tenantId' | 'created' | 'updated'>;

export type AllConditionPredicates = Condition['predicate'];
export type AllConditionSubjects = Condition['subject'];

export enum RuleSearchType {
    Perk = 'perk',
    Audience = 'segment'
    // Location = 'location',
    // Search = 'search'
}

export interface ConditionLink {
    label: string;
    link?: string;
    rulesLink?: string;
}
